export type CopyReducerState = Record<string, Record<string, string>>;
const defaultState: CopyReducerState = {}; // [locale]: data

// we initialize this reducer directly through initial state
export function copyReducer(state = defaultState): CopyReducerState {
  return state;
}
